import React from 'react';
import { Router } from '@abyss/web/ui/Router';
import { AppLayout } from '@/common/AppLayout';
import { FindCare } from './FindCare';
import { PriceCare } from './PriceCare';
import { InternalServerError } from './InternalServerError';
import { PageNotFound } from './PageNotFound';

export const Routes = () => {
  return (
    <Router.Routes title="{{title}}">
      <Router.Route path="/" element={<AppLayout />}>
        <Router.Route path="findcare/*" element={<FindCare />} />
        <Router.Route path="costestimate/*" element={<PriceCare />} />
        <Router.Route path="error" element={<InternalServerError />} />
        <Router.Route path="*" element={<PageNotFound />} />
      </Router.Route>
    </Router.Routes>
  );
};
